import { NavCardsSection } from "./section-list";
import { useSimpliCity } from "cms/hooks/use-simplicity";

const NavCardsComponent = (props) => {
    const { component } = props;
    const { webpage } = useSimpliCity();
    
    return (
        <div>
            {/*Navigation Cards Component Display*/}
            <NavCardsSection
                component={component}
                webpage={webpage}
            />
        </div>
    );
};
NavCardsComponent.displayName = "NavCardsComponent";
export { NavCardsComponent }; 